import { Box } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { alpha } from '@material-ui/core/styles/colorManipulator'

import TrackButton from 'artkive/components/Tracker/TrackButton'
import { newColors } from 'artkive/utils/theme'

export const BrandBannerWrap = withStyles((theme) => ({
  root: {
    position: 'relative',
    backgroundColor: newColors.black,
    height: `${theme.constants.brandBanner.mobileHeight}px`,
    display: 'grid',
    gridTemplateColumns: '16px 1fr 16px',
    alignItems: 'center',
    zIndex: 1200,
    padding: '0 16px',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '160px 1fr 160px',
      height: `${theme.constants.brandBanner.height}px`,
    },
    [theme.breakpoints.up('lg')]: {
      padding: '0 50px',
    },
  },
}))(Box)

export const BrandsBox = withStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px',
    [theme.breakpoints.up('md')]: {
      gap: '50px',
    },
  },
}))(Box)

export const BrandLogoButton = withStyles((theme) => ({
  root: {
    display: 'flex',
    height: `${theme.constants.brandBanner.mobileHeight}px`,
    padding: 0,
    [theme.breakpoints.up('md')]: {
      height: `${theme.constants.brandBanner.height}px`,
    },
  },
}))(TrackButton)

export const AccountButton = withStyles((theme) => ({
  root: {
    color: 'white',
    fontWeight: 500,
    padding: '16px',
    marginLeft: 'auto',
    borderRadius: 0,
    ['&:hover']: {
      backgroundColor: alpha(theme.colors.white, 0.12),
    },
  },
}))(TrackButton)
